import React from 'react';

class RelatedFilterShimemr extends React.Component {

    render() {
        return (
            <div className="FilterForLivetvBox">
                <div className="searchChannel"></div>
                <div className="RelatedFilterBtns">
                    <ul className="overflowscroll">
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                        <li><a></a></li>
                    </ul>
                </div>
                <div className="RelatedFilterBox">
                    <ul className="overflowscroll">
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                        <li>
                            <div className="fav_sld_img"></div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default RelatedFilterShimemr;